export const CLEAR_PREVIOUS_REDUCERS = "CLEAR_PREVIOUS_REDUCERS";

export const FETCH_ALL_EVENT = "FETCH_ALL_EVENT";
export const FETCH_ALL_EVENT_SUCCESS = "FETCH_ALL_EVENT_SUCCESS";
export const FETCH_ALL_EVENT_FAILED = "FETCH_ALL_EVENT_FAILED";

export const FETCH_SINGLE_EVENT = "FETCH_SINGLE_EVENT";
export const FETCH_SINGLE_EVENT_SUCCESS = "FETCH_SINGLE_EVENT_SUCCESS";
export const FETCH_SINGLE_EVENT_FAILED = "FETCH_SINGLE_EVENT_FAILED";

export const FETCH_COUNTRY = "FETCH_COUNTRY";
export const FETCH_COUNTRY_SUCCESS = "FETCH_COUNTRY_SUCCESS";
export const FETCH_COUNTRY_FAILED = "FETCH_COUNTRY_FAILED";

export const FETCH_STATE = "FETCH_STATE";
export const FETCH_STATE_SUCCESS = "FETCH_STATE_SUCCESS";
export const FETCH_STATE_FAILED = "FETCH_STATE_FAILED";

export const FETCH_CITY = "FETCH_CITY";
export const FETCH_CITY_SUCCESS = "FETCH_CITY_SUCCESS";
export const FETCH_CITY_FAILED = "FETCH_CITY_FAILED";

export const CREATE_EVENT = "CREATE_EVENT";
export const CREATE_EVENT_SUCCESS = "CREATE_EVENT_SUCCESS";
export const CREATE_EVENT_FAILED = "CREATE_EVENT_FAILED";

export const UPDATE_EVENT = "UPDATE_EVENT";
export const UPDATE_EVENT_SUCCESS = "UPDATE_EVENT_SUCCESS";
export const UPDATE_EVENT_FAILED = "UPDATE_EVENT_FAILED";

export const DELETE_EVENT = "DELETE_EVENT";
export const DELETE_EVENT_SUCCESS = "DELETE_EVENT_SUCCESS";
export const DELETE_EVENT_FAILED = "DELETE_EVENT_FAILED";

export const FETCH_EVENT_FOR_MODERATION = "FETCH_EVENT_FOR_MODERATION";
export const FETCH_EVENT_FOR_MODERATION_SUCCESS =
  "FETCH_EVENT_FOR_MODERATION_SUCCESS";
export const FETCH_EVENT_FOR_MODERATION_FAILED =
  "FETCH_EVENT_FOR_MODERATION_FAILED";

export const MODERATION_OF_EVENT = "MODERATION_OF_EVENT";
export const MODERATION_OF_EVENT_SUCCESS = "MODERATION_OF_EVENT_SUCCESS";
export const MODERATION_OF_EVENT_FAILED = "MODERATION_OF_EVENT_FAILED";


export const MODERATION_OF_EVENT_GALLERY = "MODERATION_OF_EVENT_GALLERY";
export const MODERATION_OF_EVENT_GALLERY_SUCCESS = "MODERATION_OF_EVENT_GALLERY_SUCCESS";
export const MODERATION_OF_EVENT_GALLERY_FAILED = "MODERATION_OF_EVENT_GALLRY_FAILED";


export const FETCH_USER_TO_JOIN_EVENT = "FETCH_USER_TO_JOIN_EVENT";
export const FETCH_USER_TO_JOIN_EVENT_SUCCESS =
  "FETCH_USER_TO_JOIN_EVENT_SUCCESS";
export const FETCH_USER_TO_JOIN_EVENT_FAILED =
  "FETCH_USER_TO_JOIN_EVENT_FAILED";

export const FETCH_ALL_USERS = "FETCH_ALL_USERS";
export const FETCH_ALL_USERS_SUCCESS = "FETCH_ALL_USERS_SUCCESS";
export const FETCH_ALL_USERS_FAILED = "FETCH_ALL_USERS_FAILED";

export const MODERATION_FOR_USER_EVENT = "MODERATION_FOR_USER_EVENT";
export const MODERATION_FOR_USER_EVENT_SUCCESS =
  "MODERATION_FOR_USER_EVENT_SUCCESS";
export const MODERATION_FOR_USER_EVENT_FAILED =
  "MODERATION_FOR_USER_EVENT_FAILED";

export const JOIN_NEW_USER = "JOIN_NEW_USER";
export const JOIN_NEW_USER_SUCCESS = "JOIN_NEW_USER_SUCCESS";
export const JOIN_NEW_USER_FAILED = "JOIN_NEW_USER_FAILED";

export const FETCH_IMAGES_FOR_MODERATION = "FETCH_IMAGES_FOR_MODERATION";
export const FETCH_IMAGES_FOR_MODERATION_SUCCESS =
  "FETCH_IMAGES_FOR_MODERATION_SUCCESS";
export const FETCH_IMAGES_FOR_MODERATION_FAILED =
  "FETCH_IMAGES_FOR_MODERATION_FAILED";

export const MODERATED_IMAGES = "MODERATED_IMAGES";
export const MODERATED_IMAGES_SUCCESS = "MODERATED_IMAGES_SUCCESS";
export const MODERATED_IMAGES_FAILED = "MODERATED_IMAGES_FAILED";

export const UPDATE_EVENT_BY_ADMIN = "UPDATE_EVENT_BY_ADMIN";
export const UPDATE_EVENT_BY_ADMIN_SUCCESS = "UPDATE_EVENT_BY_ADMIN_SUCCESS";
export const UPDATE_EVENT_BY_ADMIN_FAILED = "UPDATE_EVENT_BY_ADMIN_FAILED";
